import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import errorHandler from "../../../../components/unauthorizeHandler";

export function* handleFetchDashboardRegisters({ data }) {
  try {
    const params = { ...data };

    if (params.userIds && Array.isArray(params.userIds) && params.userIds.length > 0) {
      if (params.userIds.length === 1) {
        params.userId = params.userIds[0];
        delete params.userIds;
      } else {
        params.userIds = params.userIds.join(",");
      }
    }

    if (params.stockRegisterFilters && params.stockRegisterFilters.length > 0) {
      params.stockRegisterFilters.forEach(filterItem => {
        const key = Object.keys(filterItem)[0];
        const value = filterItem[key];
        if (value !== undefined && value !== null && value !== '') {
          params[key] = value;
        }
      });
      delete params.stockRegisterFilters;
    }

    const response = yield axios.get(`${baseURL}/stock-management-register/user/dashboard`, {
      params: params,
      paramsSerializer: params => {
        return new URLSearchParams(
          Object.entries(params).flatMap(([key, value]) =>
            Array.isArray(value) ? value.map(v => [key, v]) : [[key, value]]
          )
        ).toString();
      }
    });

    if (response.status === 200) {
      yield put(actions.fetchDashboardRegistersSuccess(response.data));
    } else {
      yield put(actions.fetchDashboardRegistersError(response.data));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log("Error fetching dashboard registers:", error);
    yield put(actions.fetchDashboardRegistersError(error.response?.data || error.message));
    AntdAlert.error("Failed to fetch dashboard registers");
  }
}
